module.exports = __webpack_public_path__ + "static/media/shadow.f87d9814.svg";